"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.performRequest = void 0;
const endpoint_1 = require("./endpoint");
const cirrus_request_1 = require("./cirrus-request");
const utils_1 = require("./utils");
function performRequest({ operation, socket, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const endpoint = endpoint_1.getRequestEndpoint(operation);
        yield socket.authenticated();
        if (socket.isAuthenticatedWith !== 'accessToken') {
            const hashedCirrusRequest = cirrus_request_1.buildCirrusRequest({ operation, endpoint, shouldHash: true });
            const hashedResponse = yield socket.request(hashedCirrusRequest);
            const hashedResult = utils_1.parseResult(hashedResponse);
            if (!utils_1.isHashError(hashedResult)) {
                return hashedResult;
            }
        }
        const cirrusRequest = cirrus_request_1.buildCirrusRequest({ operation, endpoint, shouldHash: false });
        const response = yield socket.request(cirrusRequest);
        return utils_1.parseResult(response);
    });
}
exports.performRequest = performRequest;
//# sourceMappingURL=performRequest.js.map